import { render } from "./SecondModelTitle.vue?vue&type=template&id=18860ad8"
import script from "./SecondModelTitle.vue?vue&type=script&lang=js"
export * from "./SecondModelTitle.vue?vue&type=script&lang=js"

import "./SecondModelTitle.vue?vue&type=style&index=0&id=18860ad8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__